module.exports = __webpack_public_path__ + "static/media/export.36bc2f27.svg";